import { Link } from "react-router-dom";
import { KeyRound } from "lucide-react";
import { useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function ResetPage() {
  const [sent, setSent] = useState(false);
  const [email, setEmail] = useState("");

  return (
    <div>
      <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-warning/15 text-warning-foreground">
        <KeyRound className="h-7 w-7" />
      </div>
      <h1 className="mt-6 text-2xl font-bold tracking-tight">
        {sent ? "Check your inbox" : "Reset your password"}
      </h1>
      <p className="mt-2 text-sm text-muted-foreground">
        {sent
          ? `If ${email} is registered, we've sent a password-reset link. It expires in 30 minutes.`
          : "Enter the email associated with your account and we'll send you a recovery link."}
      </p>

      {!sent ? (
        <form
          className="mt-6 space-y-4"
          onSubmit={(e) => {
            e.preventDefault();
            setTimeout(() => {
              setSent(true);
              toast.success("Recovery email sent");
            }, 500);
          }}
        >
          <div className="space-y-2">
            <Label htmlFor="email">Email</Label>
            <Input
              id="email"
              type="email"
              required
              autoComplete="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@company.com"
            />
          </div>
          <Button type="submit" className="w-full">Send recovery link</Button>
        </form>
      ) : (
        <div className="mt-6 rounded-lg border bg-surface-muted p-4 text-sm text-muted-foreground">
          Didn't receive it? Try again in a minute or contact support.
        </div>
      )}

      <div className="mt-6 flex items-center justify-between text-sm">
        <Link to="/auth/login" className="text-muted-foreground hover:text-foreground">
          ← Back to sign in
        </Link>
        <Link to="/auth/register" className="font-medium text-foreground hover:underline">
          Create account
        </Link>
      </div>
    </div>
  );
}
